module.exports = __webpack_public_path__ + "static/media/bg-next-draw.7847a4d2.png";